"use client";

import React, { useRef, useEffect } from "react";
import freecourses from "../home/faculty/data/freecourses";
import FreeCard from "./FreeCard";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

// Register GSAP plugins
if (typeof window !== "undefined") {
  gsap.registerPlugin(ScrollTrigger);
}

const FreeCoursesSectionInCourse = () => {
  const coursesRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Animate course cards
      gsap.fromTo(
        ".course-card",
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          stagger: 0.1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: coursesRef.current,
            start: "top 80%",
          },
        }
      );
    }, coursesRef);

    return () => ctx.revert();
  }, []);

  return (
    <div ref={coursesRef} className="courses-grid">
      {/* <div className="mt-4 flex flex-col justify-center items-center">
        <p className="text-xs lg:text-2xl">
          <span className="font-bold uppercase text-green-800 mt-4">
            first ever in India
          </span>
        </p>
        <div className="rounded-lg p-4 md:p-6 w-80 lg:w-[500px] md:h-60 border border-colorHeading hover:border-white my-9 duration-500 hover:shadow-2xl hover:shadow-colorHeading flex flex-col items-start justify-center">
          <h2 className="text-md mb-6 font-bold">
            Complete Computer Science and Engineering Course in Bengali
          </h2>
          <div className="underline"></div>
          
          <p className="mt-5">
            Faculties:{" "}
            <span className="text-green-800 font-semibold uppercase">
              Nirmalya Sengupta, Ushashi Chowdhury and Soumyadeep Paul
            </span>
          </p>
          <div className="flex items-start flex-row justify-center mt-5">
            <a href="https://www.youtube.com/playlist?list=PLCA5omKpatF8-YLcQ6ZtKbYrVx2WesPnY" target="_blank">
              <button className="border border-green-800 p-2 w-28 rounded-2xl text-xs">
                Learn
              </button>
            </a>
          </div>
        </div>
      </div> */}
      {freecourses.map((item) => (
        <FreeCard
          hero={item.heroimage}
          title={item.coursetitle}
          facultyAvatar={item.image}
          key={item.id}
          facultyName={item.faculty}
          url={item.playlist}
        />
      ))}
    </div>
  );
};

export default FreeCoursesSectionInCourse;
